module.exports = __webpack_public_path__ + "static/img/fhsy.d674d4c4.png";